import WebinarsCreateFolderModal from "./WebinarsCreateFolderModal";

export default WebinarsCreateFolderModal;
